import { CSSProperties } from 'react';

export const projectStyle: { 
  container: CSSProperties; 
  text: CSSProperties;
} = {
  container: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column', // This is valid with CSSProperties
    alignItems: 'center',
  },
  text: {
    fontSize: '20px',
    maxWidth: '800px',
    textAlign: 'center',
    margin: '0 auto',
  },
};